import {
  INFO_CARD_DESCRIPTION_STYLE,
  infoCardTitleTypography,
} from '../../../shared/boxes/infoCard/infoCardRender';
import InfoCardFace from '../../InfoCardBox/InfoCardFace';

/**
 * Aperçu d'un style de Carte info : la carte du document telle quelle, avec un
 * texte d'exemple à la place des éditeurs.
 */
const InfoCardPreview = ({ style, width = 320, sample = style?.sample }) => (
  <InfoCardFace
    style={style}
    width={width}
    title={(
      <div style={{
        ...infoCardTitleTypography(style?.titleStyle),
        width: '100%',
        ...(style?.titleColor ? { color: style.titleColor } : {}),
      }}>
        {sample?.value ?? '98 %'}
      </div>
    )}
    description={(
      <div style={{
        ...INFO_CARD_DESCRIPTION_STYLE,
        color: style?.descriptionColor || '#868e96',
      }}>
        {sample?.description ?? 'Clients satisfaits'}
      </div>
    )}
  />
);

export default InfoCardPreview;
